import { Injectable, InjectionToken } from '@angular/core';
import { get } from 'lodash';

export interface CommonAppGeneralConfig {
  commonConfig?: {
    showLoaderBlurBackground?: boolean;
    defaultCountryCode?: string;
    disableDynamicRouting?: boolean;
  };
  pageButtonsConfig?: {
    isShownDefaultTrue: boolean
  },
  formatPhoneNumberPipe?: {
    wrapCountryCodeInParentheses: boolean
  },
  fooDatepickerConfig?: {
    dateInput: string;
    monthYearLabel?: string;
    dateA11yLabel?: string;
    monthYearA11yLabel?: string;
  },
  fooTooltipConfig?: {
    active: boolean;
  },
  dynamicListingConfig?: {
    activeFooTooltip: boolean;
  }
}

export const APP_GENERAL_CONFIG = new InjectionToken<any>('APP_GENERAL_CONFIG');

@Injectable()
export class CommonGeneralConfigService {

  public config: any = {};

  constructor() { }

  setConfig(config: any): void {
    this.config = { ...this.config, ...(config || {}) };
  }

  getConfig(): any {
    return this.config;
  }

  getConfigProperty(propertyPath: string): any {
    return get(this.config, propertyPath);
  }
}
